import React from 'react';

interface InputWithIconProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  icon?: React.ReactNode;
  error?: string;
  required?: boolean;
  disableDarkMode?: boolean;
}

const InputWithIcon: React.FC<InputWithIconProps> = ({ label, icon, error, required = false, disableDarkMode = false, ...inputProps }) => {
  return (
    <div className={`w-full ${error ? 'text-red-500' : ''}`}>
      <label 
        htmlFor={inputProps.id || inputProps.name} 
        className={`block text-sm font-medium text-gray-700 ${!disableDarkMode ? 'dark:text-gray-300' : ''} mb-1`}
      >
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="relative">
        {icon && (
          <span className={`absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 ${!disableDarkMode ? 'dark:text-gray-400' : ''}`}>
            {icon}
          </span>
        )}
        <input 
          {...inputProps} 
          required={required}
          className={`w-full px-4 py-2.5 ${icon ? 'pl-10' : ''} 
            border ${error ? `border-red-500 ${!disableDarkMode ? 'dark:border-red-700' : ''}` : `border-gray-300 ${!disableDarkMode ? 'dark:border-gray-700' : ''}`} 
            bg-white ${!disableDarkMode ? 'dark:bg-gray-800' : ''} 
            text-gray-900 ${!disableDarkMode ? 'dark:text-white' : ''} 
            rounded-lg 
            focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50 focus:border-primary-500 
            disabled:bg-gray-100 disabled:text-gray-500 ${!disableDarkMode ? 'dark:disabled:bg-gray-900 dark:disabled:text-gray-400' : ''} 
            outline-none transition-colors duration-200`}
        />
      </div>
      {error && <div className={`mt-1 text-sm text-red-500 ${!disableDarkMode ? 'dark:text-red-400' : ''}`}>{error}</div>}
    </div>
  );
};

export default InputWithIcon;
